import React from 'react'

import './CommentReactionFormatText.scss'

interface CommentReactionFormatTextProps {
  children?: string
}

const CommentReactionFormatText = ({
  children,
}: CommentReactionFormatTextProps) => {
  if (!children) return <></>

  return (
    <p
      className="comment-content-paragraph"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: children }}
    />
  )
}

export default CommentReactionFormatText
